import { Avatar, AvatarImage, AvatarFallback } from '../ui/avatar';
import { cn } from '@/lib/utils';

interface CustomAvatarProps {
  src: string;
  name: string;
  className?: string;
}

const getInitials = (name: string) => {
  const names = name.trim().split(' ');
  if (names.length >= 2) {
    return `${names[0][0].toUpperCase()}${names[names.length - 1][0].toUpperCase()}`;
  }
  return `${name[0].toUpperCase()}${name[1].toUpperCase()}`;
};

export const CustomAvatar = ({ src, name, className }: CustomAvatarProps) => {
  const initials = getInitials(name);
  return (
    <Avatar className={cn('border border-input', className)}>
      <AvatarImage src={src} className="shrink-0 object-cover" />
      <AvatarFallback>{initials}</AvatarFallback>
    </Avatar>
  );
};
